import * as types from 'model/actionTypes'
import { SubscriptionT } from 'shared/types/model'

export function receiveSubscription (subscription: SubscriptionT | null) {
  return {
    type: types.RECEIVE_SUBSCRIPTION,
    subscription
  }
}
